import dayjs from "dayjs";
import React from "react";

function VideoComponent({ video }) {
  const getYouTubeId = (url) => {
    const match = url.match(
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    );
    return match ? match[1] : null;
  };

  const formatDate = (date) => dayjs(date).format("MM/DD/YYYY");

  const id = getYouTubeId(video.url)

  return (
    <div className="relative w-full gap-2 flex flex-col sm-shadow  overflow-hidden ">
      <div className="absolute top-2 right-2 bg-white text-white bg-opacity-30 border-[1px] px-2 rounded text-sm">
        {formatDate(video.createdAt)}
      </div>
      {id && (
        <iframe
          width="100%"
          src={`https://www.youtube.com/embed/${id}`}
          title={video.title}
          allowFullScreen
          className="aspect-[3/2] rounded-xl"
        ></iframe>
      )}
      <div className="p-2 text-white  text-center bgBlack border-red-700 border-2 rounded-lg">
        <h3 className="font-bold xs-shadow">{video.title}</h3>
        <p className="text-sm xs-shadow">{video.description}</p>
      </div>
    </div>
  );
}

export default VideoComponent;
